module.exports = __webpack_public_path__ + "static/img/X10毫米波雷达.b293ea9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/自动驾驶作业系统SAD200/X10毫米波雷达.png
// module id = Ih8g
// module chunks = 0